import React from 'react'
import slaRepository from '../../SlaRepository'
import useQueryFilter from '../../useQueryFilter'
import TableFilaSolicitacoesAnaliseDocumentosBase from './TableFilaSolicitacoesAnaliseDocumentosBase'

const TableFilaSolicitacoes = ({ setQuantidade, ...props }) => {
  const [query] = useQueryFilter(props.location.search)

  const fetch = () => {
    return slaRepository.filaAtual({
      empresaId: query.empresaId,
      analiseDocumentos: false
    })
  }

  return (
    <TableFilaSolicitacoesAnaliseDocumentosBase
      tipoAnaliseDocumento="Completa"
      setQuantidade={setQuantidade}
      fetch={fetch}
      {...props}
    />
  )
}

export default React.memo(TableFilaSolicitacoes)
